import React, { useEffect, useState } from "react";
import { Content } from "antd/lib/layout/layout";
import { Tabs, Row, Col, Spin, Empty, Button } from "antd";
import { CalendarOutlined } from "@ant-design/icons";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import TimelineGantt from "../../components/timeline/TimelineGantt";
import TasksFilterPanel from "../../components/timeline/TasksFilterPanel";
import { useSelector } from "react-redux";
import "../../assets/css/timeline.css";

export default function Timeline() {
  const [loading, setLoading] = useState(true);
  const [tasks, setTasks] = useState([]);
  const [plansWithTasks, setPlansWithTasks] = useState([]);
  const [visibleTaskIds, setVisibleTaskIds] = useState(null);
  const [viewScale, setViewScale] = useState("month");

  const perfCycleState = useSelector((state) => state.perfCycleState.value);
  const proHeight = document.body.clientHeight;

  useEffect(() => {
    if (perfCycleState?.id) fetchTasksData();
  }, [perfCycleState]);

  async function fetchTasksData() {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}v1/tasks/by-cycle?perfCycleId=${perfCycleState.id}`,
        {
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      const data = await response.json();
      if (data.success) {
        const allTasks = data.data || [];
        setTasks(allTasks);
        const planMap = new Map();
        allTasks.forEach((task) => {
          const pid = task.planId || "no-plan";
          if (!planMap.has(pid)) {
            planMap.set(pid, {
              id: pid,
              title: task.plan?.title || (pid === "no-plan" ? "Unassigned Tasks" : `Plan ${pid}`),
              tasks: [],
            });
          }
          planMap.get(pid).tasks.push(task);
        });
        setPlansWithTasks(Array.from(planMap.values()).filter(p => p.tasks.length > 0));
        setVisibleTaskIds(allTasks.map((t) => t.id));
      }
    } catch (e) {
      console.error("Error fetching tasks:", e);
    }
    setLoading(false);
  }

  const handleFilterChange = (ids) => setVisibleTaskIds(ids);

  const left = (
    <div className="flex items-center">
      <CalendarOutlined className="mr-2" />
      <span className="pri-font text-lg">Timeline</span>
    </div>
  );

  const renderTimeframeTab = () => {
    if (loading) return (<div className="flex justify-center items-center h-96"><Spin size="large" /></div>);
    if (tasks.length === 0) return (
      <div className="flex justify-center items-center h-96">
        <Empty description="No tasks available for this performance cycle" image={Empty.PRESENTED_IMAGE_SIMPLE} />
      </div>
    );

    return (
      <div style={{ height: '100%' }}>
        <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <span style={{ marginRight: 12, fontWeight: 'bold' }}>View:</span>
            <Button.Group>
              {['day','week','month','year'].map(scale => (
                <Button key={scale} type={viewScale===scale? 'primary':'default'} size="small" onClick={() => setViewScale(scale)}>
                  {scale[0].toUpperCase()+scale.slice(1)}
                </Button>
              ))}
            </Button.Group>
          </div>
          <div style={{ color: '#666', fontSize: '12px' }}>
            {tasks.length} tasks in {plansWithTasks.length} plans
          </div>
        </div>
        <Row gutter={16} style={{ height: 'calc(100% - 50px)' }}>
          <Col span={18} style={{ height: '100%' }}>
            <div style={{ height: '100%', position: 'relative' }}>
              <TimelineGantt tasks={tasks} visibleTaskIds={visibleTaskIds} viewScale={viewScale} />
            </div>
          </Col>
          <Col span={6} style={{ height: '100%' }}>
            <TasksFilterPanel plansWithTasks={plansWithTasks} onFilterChange={handleFilterChange} />
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} />
        <div style={{ height: proHeight - 122, overflow: "hidden", padding: "0 24px" }}>
          <Tabs defaultActiveKey="timeframe" centered>
            <Tabs.TabPane tab="Timeline" key="timeframe">
              <div style={{ height: proHeight - 200, overflow: 'hidden' }}>
                {renderTimeframeTab()}
              </div>
            </Tabs.TabPane>
          </Tabs>
        </div>
      </Content>
    </>
  );
}

